import { FlexContainer } from '@news12/storybook-news'

import styled from 'styled-components'

export const StyledStoryContentContainer = styled(FlexContainer)`
  color: ${props => props.theme.colors.textColor};

  & > * {
    margin: 0;
  }

  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    margin-top: 1rem;
    text-transform: uppercase;
    color: ${props => props.theme.colors.storyContentHeaderColor};
    font-weight: ${props => props.theme.typography.fontWeight.semibold};

    &:first-child {
      margin-top: 0;
    }
  }

  & > h1 {
    font-size: ${props => props.theme.typography.headings.h1.fontSize};
    line-height: ${props => props.theme.typography.headings.h1.lineHeight};
  }

  & > h2 {
    font-size: ${props => props.theme.typography.headings.h2.fontSize};
    line-height: ${props => props.theme.typography.headings.h2.lineHeight};
  }

  & > h3 {
    font-size: ${props => props.theme.typography.headings.h3.fontSize};
    line-height: ${props => props.theme.typography.headings.h3.lineHeight};
  }

  & > h4 {
    font-size: ${props => props.theme.typography.headings.h5.fontSize};
    line-height: ${props => props.theme.typography.headings.h5.lineHeight};
  }

  & > h5 {
    font-size: ${props => props.theme.typography.headings.h4.fontSize};
    line-height: ${props => props.theme.typography.headings.h4.lineHeight};
  }

  & > h6 {
    font-size: ${props => props.theme.typography.headings.h6.fontSize};
    line-height: ${props => props.theme.typography.headings.h6.lineHeight};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    & > h1,
    & > h2,
    & > h3,
    & > h4,
    & > h5,
    & > h6 {
      margin-top: 1.25rem;
    }
  }

  b {
    font-weight: ${props => props.theme.typography.fontWeight.medium};
  }

  .block {
    line-height: ${props => props.theme.typography.text.medium.lineHeight};
  }

  a {
    font-weight: ${props => props.theme.typography.fontWeight.medium};
    text-decoration: none;
    color: ${props => props.theme.colors.storyContentLinkColor};
  }

  .list {
    ul,
    ol {
      list-style: disc;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      padding-left: 1.15rem;
      margin: 0;

      li {
        line-height: ${props => props.theme.typography.text.medium.lineHeight};
      }
    }

    ol {
      list-style: decimal;
    }
  }

  .image {
    padding: 0.75rem 0;
    img {
      width: 100%;
    }

    em {
      display: block;
      color: ${props => props.theme.colors.darkGray};
      font-size: ${props => props.theme.typography.text.tiny.fontSize};
      font-style: normal;
      margin-top: 0.75rem;
    }
  }
    
  .carousel-embed {
    width: 100%;
    height: 826px;

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      height: 768px;
    }
      
    @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
      height: 690px;
    }
  }

  table {
    margin: 1.25rem 0;
    border-collapse: collapse;
    width: 100%;
    display: block;
    overflow-x: auto;
    white-space: nowrap;

    @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
      display: table;
      white-space: unset;
    }

    td,
    th {
      text-align: center;
      padding: 1.5rem;
      border-bottom: 1px solid ${props => props.theme.colors.darkGray};

      &:first-of-type {
        text-align: left;
      }
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
      th,
      td {
        padding: 1.5rem 0.5rem;
      }
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      th,
      td {
        padding: 1.5rem 0;
      }
    }

    th {
      font-size: ${props => props.theme.typography.text.medium.fontSize};
      font-weight: ${props => props.theme.typography.fontWeight.medium};
    }

    tr {
      &:first-of-type {
        td,
        th {
          padding-top: 0;
          border-width: 2px;
          border-color: ${props => props.theme.colors.storyContentTableBorderColor};
        }
      }
    }
  }

  hr {
    border-color: ${props => props.theme.colors.darkGray};
  }

  blockquote {
    p {
      margin: 0;
      font-style: italic;
      font-weight: ${props => props.theme.typography.fontWeight.medium};
    }
  }

  .embed {
    display: flex;
    flex-direction: column;
    align-items: center;

    .fb-post {
      display: block;
      margin: 0 auto;
      max-width: 100%;
      overflow: auto;
      position: relative;

      iframe {
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    & > div:not([class])  {
      width: 100%;
        
      iframe {
        max-width: 100%;
      }
    }

    &.youtube-embed {
      position: relative;
      max-width: 640px;
      width: 100%;
      &:before {
        content: '';
        display: block;
        padding-top: 56.25%; // 16x9 aspect ratio for the YouTube embed
      }

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100% !important; // Since YouTube embed sets the width inline, we'll use !important to be sure that it's 100%
        height: 100%;
      }
    }
  }
`
